import { render, staticRenderFns } from "./r-product-group-page.vue?vue&type=template&id=742bbdff"
import script from "./r-product-group-page.vue?vue&type=script&lang=js"
export * from "./r-product-group-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('742bbdff')) {
      api.createRecord('742bbdff', component.options)
    } else {
      api.reload('742bbdff', component.options)
    }
    module.hot.accept("./r-product-group-page.vue?vue&type=template&id=742bbdff", function () {
      api.rerender('742bbdff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/product-group/r-product-group-page.vue"
export default component.exports